import { Component } from '@angular/core';

@Component({
  selector: 'app-tin-spinner',
  template: `<mat-spinner diameter="80" color="accent"></mat-spinner>`
})
export class TinSpinnerComponent {
  constructor() {}
}
